import { render, staticRenderFns } from "./poolTransactions.vue?vue&type=template&id=e2189a56&scoped=true"
import script from "./poolTransactions.vue?vue&type=script&lang=js"
export * from "./poolTransactions.vue?vue&type=script&lang=js"
import style0 from "./poolTransactions.vue?vue&type=style&index=0&id=e2189a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2189a56",
  null
  
)

export default component.exports